export default __webpack_public_path__ + "static/media/services.2fa6aedb.svg";